import { AfterViewInit, Component, Inject, OnDestroy, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTable } from "@angular/material/table";
import { FileLogger, Tools } from "@comunicare/comunicare-helper";
import { ITPDAParticipant } from "@comunicare/comunicare-interfaces";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { TPDAsService } from "../../tpdas.service";
import { ParticipantDataSource } from "./participant.datasource";

@Component({
  selector: "app-participant-modal",
  templateUrl: "./participant-modal.component.html",
  styleUrls: ["./participant-modal.component.scss"],
})
export class ParticipantModalComponent implements AfterViewInit, OnDestroy {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatTable) table: MatTable<ITPDAParticipant>;

  public datasource: ParticipantDataSource = new ParticipantDataSource();
  public displayedColumns: string[] = ["identifier", "inscriptionDate", "lang", "personnalData", "actions"];
  public isDownloading = false;

  private onDestroy$ = new Subject<void>();

  constructor(
    private tpdaService: TPDAsService,
    private translateService: TranslateService,
    private snackbar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA)
    public data: { participants: ITPDAParticipant[] }
  ) {
    this.datasource.loadData(this.data.participants);
  }

  ngAfterViewInit(): void {
    this.initPaginatorAndSort();
  }
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
  private initPaginatorAndSort(): void {
    this.datasource.sort = this.sort;
    this.datasource.paginator = this.paginator;
  }

  public async downloadConsents(participant: ITPDAParticipant): Promise<void> {
    this.isDownloading = true;
    this.snackbar.open(this.translateService.instant("export.message"), "ok", { duration: 3000 });
    try {
      const blob = await this.tpdaService.getTPDAConsentFormsPDFs(participant.TPDAId, participant.identifier);
      const url = URL.createObjectURL(blob);
      Tools.downloadBlob(blob, url.split("/")[url.split("/").length - 1]);
    } catch (err) {
      FileLogger.error("TPDA Participant modal", "downloadConsents()", err);
      this.snackbar.open(this.translateService.instant("api.errors.unknowerror"), undefined, {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    }
    this.isDownloading = false;
  }

  public async downloadQRs(participant: ITPDAParticipant): Promise<void> {
    this.isDownloading = true;
    this.snackbar.open(this.translateService.instant("export.message"), "ok", { duration: 3000 });
    try {
      const blob = await this.tpdaService.getTPDAQRsPDFs(participant.TPDAId, participant.identifier);
      const url = URL.createObjectURL(blob);
      Tools.downloadBlob(blob, url.split("/")[url.split("/").length - 1]);
    } catch (err) {
      FileLogger.error("TPDA Participant modal", "downloadQRs()", err);
      this.snackbar.open(this.translateService.instant("api.errors.unknowerror"), undefined, {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    }
    this.isDownloading = false;
  }
}
